import React from "react";
var __jsx = React.createElement;
import { FormattedMessage } from 'react-intl';
import { PublicationStatus } from '@uno/common-cms';
import BackButton from 'components/common/BackButton';
import { PublishButton } from 'components/common/material-ui/custom-components/PublishButton.style';
import { ButtonContainer, CustomScheduledIcon } from '../PublishDialog.style';

var ScheduleActionButton = function ScheduleActionButton(_ref) {
  var publicationStatus = _ref.publicationStatus,
      onConfirm = _ref.onConfirm,
      onBack = _ref.onBack,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return __jsx(ButtonContainer, null, __jsx(BackButton, {
    onClick: onBack
  }), __jsx(PublishButton, {
    variant: "outlined",
    publicationStatus: PublicationStatus.SCHEDULED,
    onClick: function onClick() {
      return onConfirm(PublicationStatus.SCHEDULED);
    },
    disabled: disabled
  }, __jsx(CustomScheduledIcon, null), __jsx(FormattedMessage, {
    id: publicationStatus === PublicationStatus.SCHEDULED ? "publish-modal.scheduled.confirm-reschedule" : "publish-modal.scheduled.confirm-schedule"
  })));
};

export default ScheduleActionButton;